import React, { useEffect, useState } from 'react' 
import { AutoComplete, Button, Typography } from '../../../../components/common'
import { Select } from 'flowbite-react'
import { selectFieldTheme } from '../../../../theme/flowbite.custom.theme'
import { useSearchParams } from 'react-router-dom'

export const SelectClients = ({ 
    onSelectFilterByClient = () => null,
    value = "",
    filterParams = {},
    supportClientList = [],
    clientLoader = false }) => {
    const [selectedItem, setSelectedItem] = useState({})
    const [status, setStatus] = useState('');

    const [searchParams] = useSearchParams();
    const activeStatus = searchParams.get("status") || "";

    const onSelectReportee = (reportee) => setSelectedItem(reportee);

    const getList = () => (!!supportClientList?.length && supportClientList?.map(client => ({ ...client, value: client?.name }))) || []

    const handleApply = () => onSelectFilterByClient({ url: selectedItem?.url, status: status });

    const handleClearText = () => {
        setSelectedItem({});
        setStatus('1');
        onSelectFilterByClient({ url: null, status: null })
    }

    const getStatusList = !!filterParams?.status?.length && filterParams?.status?.filter(e => e?.name !== 'RESET');

    const onChangeStatus = (e) => setStatus(e.target.value);

    useEffect(() => {
        if (value !== "" && getList()?.length) {
            const selectedItem = (!!getList()?.length && getList()?.find(client => client?.url === value)) || {}
            setSelectedItem(selectedItem)
        }
        //eslint-disable-next-line 
    }, [value])

    useEffect(() => {
        setStatus(activeStatus)
    }, [activeStatus])

    return (
        <div className='flex flex-col gap-4 max-w-lg'>
            <div className="mb-16 flex flex-col gap-4">
                <div>
                    <Typography variant="lg" className="font-semibold" text="Filter by" />
                </div>
                <div>
                    <AutoComplete
                        options={getList()}
                        required={false}
                        selecteditem={selectedItem}
                        disabled={clientLoader}
                        onChangeCustomerName={onSelectReportee}
                        loader={clientLoader}
                        placeholderText={"Select Client"} label={"Company Name"} />

                </div>
                <div>
                    <div className='flex flex-col gap-1 h-fit'>
                        <label htmlFor='raised_by' className='mb-1.5 Z-10 block text-sm font-semibold text-secondary-400' >
                            Ticket Status
                        </label>
                        <Select
                            theme={selectFieldTheme}
                            sizing={"sm"}
                            onChange={onChangeStatus}
                            id="raised_by"
                            value={status}
                            className="form-control-div">
                            <option value={"1"}>All Status</option>
                            {!!getStatusList?.length && getStatusList?.map(({ name, value }) => (
                                <option key={name} value={value}>
                                    {name}
                                </option>
                            ))}
                        </Select>
                    </div>
                </div>

            </div>
            <div className='flex w-full justify-end gap-4'>
                <Button variant='tertiary' className="w-fit" text="Clear" onClick={handleClearText} />
                <Button variant='primary' disabled={clientLoader} onClick={handleApply} className="w-fit " text="Apply" />
            </div>
        </div>
    )
}
